import React from "react";
import LeadsNavbar from "../Components/LeadsNavbar/LeadsNavBar";
import RoutsPages from "../Pages/Routs/RoutsPages"

const LeadsPage = () => {

  return (
    <>
    <LeadsNavbar />
    <RoutsPages />
    
    </>
  );
}

export default LeadsPage;